import { Box, Button, CircularProgress, Dialog } from "@mui/material"
import CloseModalButton from "../../../../components/CloseModalButton"
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled"
import { Autoclave } from "../types"
import { getBackgroundComplianceColor } from "../../../../helpers/compliance"
import { ComplianceStatus } from "../../../../types"
import { getAutoclaves, updateAutoclave } from "../../../../services/biologicalServices"
import { Dispatch, SetStateAction, useState } from "react"
import { addError, addSuccess } from "../../../../redux/alerts"
import { useAppDispatch } from "../../../../redux/store"

type AutoclaveStatusModal = {
  open: boolean,
  autoclave: Autoclave,
  customerNumber: string,
  handleClose: () => void,
  setAutoclaves: Dispatch<SetStateAction<Autoclave[]>>,
}

const AutoclaveStatusModal = (props: AutoclaveStatusModal) => {
  const {
    open,
    autoclave,
    customerNumber,
    setAutoclaves,
    handleClose,
  } = props

  const [isUpdating, setIsUpdating] = useState<boolean>(false)
  const dispatch = useAppDispatch();
  const handleSave = async () => {
    try {
      setIsUpdating(true)

      const { autoclave_id, autoclave_name, autoclavetype_id, autoclave_brand, autoclave_model, autoclave_serial, autoclave_frequency } = autoclave
      const autoclavePayload = {
        customer_number: customerNumber,
        autoclave_id,
        autoclave_name,
        autoclavetype_id,
        autoclave_brand,
        autoclave_model,
        autoclave_serial,
        autoclave_frequency,
        active: !autoclave.active,
      }

      await updateAutoclave(customerNumber, autoclavePayload)
      const autoclaveData = await getAutoclaves(customerNumber)

      setAutoclaves(autoclaveData)
      setIsUpdating(false)

      handleClose()
      dispatch(addSuccess(`${autoclave.autoclave_name} ${autoclave.active ? 'Deactivated' : 'Activated'}`))
    } catch (err) {
      console.error(err)
      setIsUpdating(false)
      dispatch(addError(err instanceof Error ? err.message : 'There was an error updating the autoclave, please try again later'))
      handleClose()
    }
  }

  const status = autoclave.active
    ? ComplianceStatus.Expired
    : ComplianceStatus.Ok

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <CloseModalButton handleClose={handleClose} />
        <StyledDialogTitle>
          <Box className="flex flex-align-center c-g-8">
            <span className={`m-r-8 compliance-circle compliance-circle-large ${getBackgroundComplianceColor(status)}`} />
            <span>
              {autoclave.active ? 'Deactivate' : 'Activate'} Autoclave
            </span>
          </Box>
        </StyledDialogTitle>
        <StyledDialogContent>
          Are you sure you want to {autoclave.active ? 'Deactivate' : 'Activate'} {autoclave.autoclave_name}?
        </StyledDialogContent>
        <StyledDialogFooter>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button variant="contained" onClick={handleSave} disabled={isUpdating}>
            {isUpdating ? <CircularProgress size={20} /> : 'Yes'}
          </Button>
        </StyledDialogFooter>
      </Dialog>
    </>
  )
}

export default AutoclaveStatusModal
